export default __webpack_public_path__ + "static/sl-d589fff777c6686b3b915c9abb3977d9.svg";